// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"ceffa024","317":"678a9d27","413":"a614c016","917":"2e0c716e"}[chunkId] + ".chunk.js";
};